import { createFileRoute } from '@tanstack/react-router'

import { GlobalRoleType } from '@beaded/models'

import { requireGlobalRole } from 'lib/routeGuards'

import ReportTemplates from 'pages/ReportTemplates'

export const Route = createFileRoute('/_auth/_global/report-templates/')({
  beforeLoad: requireGlobalRole(
    GlobalRoleType.GLOBAL_VIEW,
    GlobalRoleType.GLOBAL_EDIT,
    GlobalRoleType.GLOBAL_ADMIN,
  ),
  component: ReportTemplates,
})
